import DiscoveringFeature from './DiscoveringFeature.component';

export default DiscoveringFeature;